import React, { Fragment, Component } from "react";
import ViewTabs from "./ViewTabs";
import Keywords from "./filters/Keywords";
import DateTab, { DateType } from "./filters/DateTab/index";
import BrowsingHistory from "./filters/BrowsingHistory";
import EventResults from "./EventResults";
import BrowsingHistoryEvents from "./BrowsingHistoryEvents";
import CTASections from "./CTASections";
import HelpSection from "./HelpSection";
import { Cart, Filters, Event } from "../MasterImageSearch/components/types";
import { getParameterByName } from "../../utils/BrowserHelper";
import PhotographerSearch from "./filters/PhotographerSearch";
import PhotographerResults from "./PhotographerResults";

export type PageView = "keywords" | "date" | "history" | "photographer";
interface FindPhotosLandingProps {
  photosAPI: string;
  addToCartAPI: string;
  removeFromCartAPI: string;
  cart: Cart;
  initialFilters: Filters;
  adminUser: boolean;
  embedded: boolean;
  ios: boolean;
  selfieSearchS3Bucket: string;
  currentUserId: number;
  currentUserCountry: string;
  photographersPath: string;
}

interface FindPhotosLandingState {
  activeView: PageView;
  filterKeywords: string | null;
  filterPhotographers: string | null;
  filterDate: DateType | null;
}

class FindPhotosLanding extends Component<
  FindPhotosLandingProps,
  FindPhotosLandingState
> {
  constructor(props: FindPhotosLandingProps) {
    super(props);
    this.state = {
      activeView: props.initialFilters.referenceImage ? "selfie" : "keywords",
      filterKeywords: getParameterByName("event"),
      filterPhotographers: null,
      filterDate: null
    };
  }
  componentDidMount() {
    if (!this.props.currentUserId) {
      $(".open-login, .switch-login").on("click", function (e) {
        e.preventDefault();
        $("#login-pop .geo-popup__cont").addClass("geo-hidden");
        $("#login-pop .geo-popup--login").removeClass("geo-hidden");
        $("body").addClass("geo-popopen");
        $("#login-pop").addClass("geo-open");
      });

      $(".open-signup, .switch-si").on("click", function (e) {
        e.preventDefault();
        if (window.location.pathname === "/lp/event_organisers") {
          $("#hs-contact-form").modal("show");
        } else {
          $("#login-pop .geo-popup__cont").addClass("geo-hidden");
          $("#login-pop .geo-popup--se").removeClass("geo-hidden");
          $("body").addClass("geo-popopen");
          $("#login-pop").addClass("geo-open");
        }
      });

      $(".geo-popup__bg, .geo-popup__close").on("click", function (e) {
        e.preventDefault();
        $(this).parents(".geo-popup").removeClass("geo-open");
        $("body").removeClass("geo-popopen");
      });
    }
  }

  componentWillUnmount() {
    $(".open-login, .switch-login, .open-signup, .switch-si").off("click");
    $(".geo-popup__bg, .geo-popup__close").off("click");
  }

  handleSignUpClick = () => {
    $(".open-signup").click();
  };

  public render() {
    return (
      <div id="website-photos">
        <section className="photos-event-section bg-lt-green">
          <div className="container-lock">
            <h3 className="text-center">Find Photos by</h3>
            <ViewTabs
              activeTab={this.state.activeView}
              setActiveTab={(activeView: PageView) =>
                this.setState({ activeView })
              }
            />
            <div className="tab-content">{this.renderFilters()}</div>
          </div>
        </section>
        {this.renderResults()}
        {<HelpSection />}
        {!this.props.currentUserId && (
          <div className="geo-signin-div">
            <h2 className="highlighted">
              Sell your sports photos with GeoSnapShot{" "}
            </h2>
            <div className="flex-row">
              <button
                className="primary-btn icon-btn"
                onClick={this.handleSignUpClick}
              >
                Sign up for free today
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  private renderFilters = () => {
    switch (this.state.activeView) {
      case "keywords":
        return (
          <Keywords
            keywords={this.state.filterKeywords || ""}
            updateKeywords={filterKeywords => {
              this.setState({ filterKeywords });
            }}
          />
        );
      case "date":
        return (
          <DateTab
            date={this.state.filterDate}
            onCancel={() => {
              if (!this.state.filterDate)
                this.setState({
                  activeView: "keywords"
                });
            }}
            updateDate={filterDate => {
              this.setState({ filterDate });
            }}
          />
        );
      case "history":
        return <BrowsingHistory />;
      case "photographer":
        return (
          <PhotographerSearch
            name={this.state.filterPhotographers || ""}
            updateName={filterPhotographers => {
              this.setState({ filterPhotographers });
            }}
          />
        );
    }
  };

  private renderResults = () => {
    switch (this.state.activeView) {
      case "keywords":
        return (
          <Fragment>
            {this.state.filterKeywords ? (
              <EventResults keywords={this.state.filterKeywords} date={null} />
            ) : (
              <CTASections
                showMonthDatePopup={this.showMonthDatePopup}
                photographersPath={this.props.photographersPath}
              />
            )}
          </Fragment>
        );
      case "date":
        return <EventResults date={this.state.filterDate} keywords={null} />;
      case "history":
        return <BrowsingHistoryEvents />;
      case "photographer":
        return (
          <Fragment>
            {this.state.filterPhotographers ? (
              <PhotographerResults
                photographer={this.state.filterPhotographers}
              />
            ) : (
              <CTASections
                showMonthDatePopup={this.showMonthDatePopup}
                photographersPath={this.props.photographersPath}
              />
            )}
          </Fragment>
        );
      default:
        return null;
    }
  };

  private showMonthDatePopup = () => {
    this.setState({
      activeView: "date"
    });
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  };
}

export default FindPhotosLanding;
